<div class="manax-sidebar-container">
  <mat-sidenav-container class="manax-sidebar-sidenav-container" autosize>

    <!-- left panel -->
    <mat-sidenav #snav [mode]="isMode()" fixedTopGap="56" [opened]="!isMobileMenu()"
      class="manax-side-navbar bg-lavuro" style="width: auto;">
      <app-manax-side-navbar (selected)="sidenavChange()" [collapsed]="menuCollapsed"></app-manax-side-navbar>
    </mat-sidenav>

    <!-- right panel -->
    <mat-sidenav-content id="router-container" infinite-scroll (scroll)="onLiteScroll()" (scrolled)="onScroll()"
      [scrollWindow]="false">

      <mat-toolbar class="manax-sidebar-toolbar pl-0">
        <button (click)="onSelect()" class="pull-left expansion-button color-purple-manax">
          <mat-icon *ngIf="menuCollapsed">arrow_forward_ios_new</mat-icon>
          <mat-icon *ngIf="!menuCollapsed">arrow_back_ios_new</mat-icon>
        </button>

        <app-header class="d-none d-md-block px-0 pull-right "
          style="width: 100%; border-bottom: 1px solid #e2ebfa;"></app-header>
      </mat-toolbar>

      <div class="router-container">
        <router-outlet></router-outlet>
      </div>

      <br><br><br>
      <br><br><br>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!--app-manax-chat [show]="showChatPanel"></app-manax-chat-->

  <!--(mouseenter)="showWhatsappLabel = true" (mouseleave)="showWhatsappLabel = false"-->
  <!--<button type="button" *ngIf="isManax" class="btn btn-info text-white m-0 p-1 whatsapp" (click)="showChat()">
    <span class="label">Manaxito</span>
  </button>
  -->
</div>